import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getAttendanceSettingList, delSetting } from 'api/Attendance';
import Edit from './modal/edit-group';
import Scheduling from './modal/scheduling';
import commonHolidayRules from './modal/common-holiday-rules';
import { checkSettingRelation } from 'api/settings';
// import commonHoliday from '../modal/common-holiday'

export default {
  components: {
    Edit: Edit,
    // commonHoliday,
    Scheduling: Scheduling,
    commonHolidayRules: commonHolidayRules
  },
  data: function data() {
    return {
      // 公休弹窗visible
      // holidayVisible: false,
      pagina: {
        page: 1,
        size: 20,
        total: 0
      },
      loading: false,
      form: {},
      tableData: [{}],
      type: 1,
      // 1 2 新建 编辑
      visible: 1 // 页面展示逻辑 4公告假期 3 排班
    };
  },
  created: function created() {
    // 获取考勤组列表
    this.handleGetAttendanceSettingList();
  },
  methods: {
    // 新建 编辑 排班
    open: function open(num) {
      this.visible = num || 1;
    },
    createGroup: function createGroup() {
      var _this = this;
      this.open(2);
      this.type = 1;
      this.$nextTick(function () {
        _this.$refs.edit.init();
      });
    },
    // 获取考勤组列表
    handleGetAttendanceSettingList: function handleGetAttendanceSettingList() {
      var _this2 = this;
      this.loading = true;
      var msg = _objectSpread(_objectSpread({}, this.form), this.pagina);
      getAttendanceSettingList(msg).then(function (res) {
        _this2.tableData = res.data.result;
        _this2.pagina.total = Number(res.data.count);
      }).finally(function () {
        _this2.loading = false;
      });
    },
    // 分页相关
    handleSizeChange: function handleSizeChange(val) {
      this.pagina.size = val;
      this.handleGetAttendanceSettingList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pagina.page = val;
      this.handleGetAttendanceSettingList();
    },
    // 删除考勤组
    handleDelSetting: function handleDelSetting(row) {
      var _this3 = this;
      this.$confirm(this.$t('835'), this.$t('836'), {
        confirmButtonText: this.$t('131'),
        cancelButtonText: this.$t('66'),
        type: 'warning'
      }).then(function () {
        delSetting(row).then(function (res) {
          _this3.handleGetAttendanceSettingList();
        });
      });
    },
    // 同意
    confirmAgree: function confirmAgree(params) {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _yield$checkSettingRe, data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return checkSettingRelation({
                id: params.id
              });
            case 2:
              _yield$checkSettingRe = _context.sent;
              data = _yield$checkSettingRe.data;
              if (!data.check_result) {
                _this4.$confirm(_this4.$t('i18n.3a2455530ae94812bfb7c8f22b3f69ff'), _this4.$t('1726'), {
                  confirmButtonText: _this4.$t('131'),
                  cancelButtonText: _this4.$t('66'),
                  type: 'warning'
                }).then(function () {
                  _this4.type = 2;
                  _this4.open(2);
                  _this4.$nextTick(function () {
                    _this4.$refs.edit.init(params);
                  });
                });
              } else {
                _this4.type = 2;
                _this4.open(2);
                _this4.$nextTick(function () {
                  _this4.$refs.edit.init(params);
                });
              }
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    handlerShe: function handlerShe(row, num) {
      var _this5 = this;
      this.open(num);
      if (num === 3) this.$nextTick(function () {
        return _this5.$refs.scheding.init(row.id);
      });
    }
  }
};